// Vendor imports
const React = require('react')
const ReactPopper = require('react-popper')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Portal = require('client-v2/common/components/portal')
const WindowResizeListener = require('client-v2/common/components/window-resize-listener')
const { cloneElementWithDomRef } = require('client-v2/common/components/utils')

/**
 * If the child is not a DOM element, is **must** handle its `forwardedRef` prop!
 * @see `cloneElementWithDomRef` in `client-v2/common/components/utils.js`
 */
function PopperAnchor(props) {
  const child = React.Children.only(props.children)
  if (props.isDisabled) {
    return child
  }
  return (
    tag(ReactPopper.Manager,
      tag(ReactPopper.Reference,
        ({ ref }) => cloneElementWithDomRef(child, ref)
      ),
      tag(Portal, {
        container: props.portalContainer
      },
        tag(ReactPopper.Popper, getPopperProps(props),
          (popperProps) => tag([
            tag(WindowResizeListener, {
              animate: true,
              timeout: props.updateAfterResizeDelay,
              onResize: popperProps.scheduleUpdate
            }),
            props.renderPopper(popperProps)
          ])
        )
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  PopperAnchor.propTypes = {
    children: PropTypes.node,
    // Popper options
    modifiers: PropTypes.object,
    placement: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
    // Flags
    isDisabled: PropTypes.bool,
    // Values
    portalContainer: Portal.containerPropType.isRequired,
    updateAfterResizeDelay: PropTypes.number,
    // Render props
    renderPopper: PropTypes.func.isRequired
  }
}

module.exports = PopperAnchor

// Helpers

function getPopperProps(props) {
  let { modifiers, placement } = props
  // Treat multiple placements as preferred flip behavior
  if (Array.isArray(placement)) {
    modifiers = {
      ...modifiers,
      flip: {
        behavior: placement
      }
    }
    placement = placement[0]
  }
  return { modifiers, placement }
}
